export default __webpack_public_path__ + "static/media/ja1.296e06b8.jpg";